<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    <div class="divider w-100 mt-40"></div>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 mt-40">
        <div class="t2-semi-bold">{{ 'i18n_af_labelPaymentInformation' | translate }}</div>
        <ui-kit-button type="text"
                       [label]="(expanded ? 'i18n_af_buttonCollapse' : 'i18n_af_buttonFillData') | translate"
                       (clickListener)="toggleExpanded()"/>
    </div>
    @if (expanded) {
        <form [formGroup]="form" class="w-824 mt-24">
            @if (form.hasError('merchantInfoAllOrNothing') && form.touched) {
                <div class="t5 c-secondary-red-900 mb-16">
                    {{ 'i18n_af_fieldValidationMerchantInfoAllOrNothing' | translate }}
                </div>
            }
            <div class="grid-form-container">
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ 'i18n_af_labelMerchantName' | translate }} {{ form.controls.name.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.value.name">
                        <input matInput
                               formControlName="name"
                               [placeholder]="'i18n_af_placeholderMerchantName' | translate"
                               name="name"/>
                        @if (form.controls.name.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.name.hasError('minlength') || form.controls.name.hasError('maxlength')
                            || form.controls.name.hasError('pattern')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationInvalidFormat' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ 'i18n_af_labelMerchantId' | translate }} {{ form.controls.merchantId.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.value.merchantId">
                        <input matInput
                               formControlName="merchantId"
                               [placeholder]="'i18n_af_placeholderMerchantId' | translate"
                               name="merchantId"/>
                        @if (form.controls.merchantId.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.merchantId.hasError('minlength') || form.controls.merchantId.hasError('maxlength')
                            || form.controls.merchantId.hasError('pattern')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationInvalidFormat' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <af-dictionary-selector dictionaryName="merchant_category_code"
                                        [control]="form.controls.categoryCode"
                                        [predefinedValue]="form.controls.categoryCode.value"
                                        [hasSearch]="true"
                                        [showCodeWithName]="true"
                                        label="i18n_af_labelMerchantCategoryCode"
                                        placeholder="i18n_af_placeholderMerchantCategoryCode"/>
                <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                    <div
                        class="t5 c-primary-gray-600">{{ 'i18n_af_labelTerminalId' | translate }} {{ form.controls.terminalId.hasValidator(Validators.required) ? '*' : '' }}
                    </div>
                    <mat-form-field class="w-100 mt-4"
                                    [class.value-not-empty]="form.value.terminalId">
                        <input matInput
                               formControlName="terminalId"
                               [placeholder]="'i18n_af_placeholderTerminalId' | translate"
                               name="terminalId"/>
                        @if (form.controls.terminalId.hasError('required')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationRequired' | translate }}
                            </mat-error>
                        }
                        @if (form.controls.terminalId.hasError('minlength') || form.controls.terminalId.hasError('maxlength')
                            || form.controls.terminalId.hasError('pattern')) {
                            <mat-error class="c-secondary-red-900">
                                {{ 'i18n_af_fieldValidationInvalidFormat' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <af-ip-input class="w-476"
                             [control]="form.controls.deviceIp"
                             label="i18n_af_labelDeviceIp"
                             placeholder="i18n_af_placeholderDeviceIp"
                             name="deviceIp"/>
            </div>
        </form>
    }
</div>
